import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuthSession, signOut } from '../lib/auth';

export function Nav() {
  const { user } = useAuthSession();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close drawer when route changes (after a NavLink click)
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Lock body scroll while drawer is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }
    return undefined;
  }, [open]);

  return (
    <>
      {/* Mobile-only hamburger button — fixed top-left */}
      <button
        type="button"
        className={`app-nav__toggle${open ? ' app-nav__toggle--open' : ''}`}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span /><span /><span />
      </button>

      {/* Backdrop — only when drawer is open */}
      {open && <div className="app-nav__backdrop" onClick={() => setOpen(false)} />}

      <aside
        className={`app-nav${open ? ' app-nav--open' : ''}`}
        aria-hidden={!open && typeof window !== 'undefined' && window.innerWidth < 768 ? true : undefined}
      >
        <Link to="/" className="app-nav__brand">
          <span className="app-nav__rule">Vol. 01 · Ed. 001</span>
          <h1 className="app-nav__title">
            Stax<br />
            <em>Reply</em>
          </h1>
        </Link>

        <nav className="app-nav__menu">
          <NavLink to="/outreach" className="app-nav__link">
            <span className="app-nav__num">01</span>
            <span>Outreach</span>
          </NavLink>
          <NavLink to="/engagement" className="app-nav__link">
            <span className="app-nav__num">02</span>
            <span>Engagement</span>
          </NavLink>
          <NavLink to="/templates" className="app-nav__link">
            <span className="app-nav__num">03</span>
            <span>Templates</span>
          </NavLink>
          <NavLink to="/podcast" className="app-nav__link">
            <span className="app-nav__num">04</span>
            <span>Podcast</span>
          </NavLink>
          <NavLink to="/interviews" className="app-nav__link">
            <span className="app-nav__num">05</span>
            <span>Interviews</span>
          </NavLink>
          <NavLink to="/pain-points" className="app-nav__link">
            <span className="app-nav__num">06</span>
            <span>Pain Points</span>
          </NavLink>
          <NavLink to="/user-stories" className="app-nav__link">
            <span className="app-nav__num">07</span>
            <span>User Stories</span>
          </NavLink>
          <NavLink to="/settings" className="app-nav__link">
            <span className="app-nav__num">08</span>
            <span>Settings</span>
          </NavLink>
        </nav>

        <footer className="app-nav__user">
          <span className="app-nav__user-email">{user?.email ?? '—'}</span>
          <button type="button" className="app-nav__signout" onClick={() => signOut()}>
            sign out
          </button>
        </footer>
      </aside>
    </>
  );
}
